/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Happy_Pearl_Finch_LiftInputs */

const en_happy_pearl_finch_lift = /** @type {(inputs: Happy_Pearl_Finch_LiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access rights`)
};

const de_happy_pearl_finch_lift = /** @type {(inputs: Happy_Pearl_Finch_LiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugriffsrechte`)
};

/**
* | output |
* | --- |
* | "Access rights" |
*
* @param {Happy_Pearl_Finch_LiftInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const happy_pearl_finch_lift = /** @type {((inputs?: Happy_Pearl_Finch_LiftInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Happy_Pearl_Finch_LiftInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_happy_pearl_finch_lift(inputs)
	return de_happy_pearl_finch_lift(inputs)
});